import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useResetScroll = () => {
  const location = useLocation();

  useEffect(() => {
    // 매거진 페이지에서는 스크롤 리셋하지 않음 (자체적으로 위치 복원)
    if (location.pathname.startsWith('/monthly-threads/')) {
      return;
    }
    
    window.scrollTo(0, 0);
  }, [location.pathname]);
}; 